/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMountain = createReactComponent("outline", "mountain", "IconMountain", [["path", { "d": "M3 20h18l-6.921 -14.612a2.3 2.3 0 0 0 -4.158 0l-6.921 14.612z", "key": "svg-0" }], ["path", { "d": "M7.5 11l2 2.5l2.5 -2.5l2 3l2.5 -2", "key": "svg-1" }]]);

export { IconMountain as default };
//# sourceMappingURL=IconMountain.mjs.map
